/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo, useState } from 'react'

import { const_var, params } from '../../../../../../redux/reducers/reducer';
import { controls } from '../../../../../../redux/reducers/common/eventReducer';

import { delModel, extrudeSettings, roofPattern } from '../../../../../../utils/Functions';
import { CSG } from '../../../../../../assets/libs/csg-lib';
import useMouseEvents from '../../../../../../hooks/useMouseEvents';
import { MaterialInnerWall, MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../CustomMaterial';

const WallModel = () => {
    const [frontWallCloseState, setFrontWallCloseState] = useState(0);
    const [backWallCloseState, setBackWallCloseState] = useState(0);
    const [sideWallCloseState, setSideWallCloseState] = useState(0);
    const [sideWallLeftPorchSize, setSideWallLeftPorchSize] = useState(0);
    const [sideWallRightPorchSize, setSideWallRightPorchSize] = useState(0);

    const cbFrontBackWallOffset = 0.16;
    const wallThickness = 0.005;

    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement != undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false

    let verticalHorizontalPos = {"x": params.leanB_p_d /2,"y" : ((params.p_w_c_n && params.p_b_c_b_b_f === 'Close') ? 2.935 : 0), "z" : -params.p_d / 2}
    let verticalHorizontalRot = {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
    let patternLength = params.leanB_p_h + ((params.b_l_t_r_pB / 12) * (params.leanB_p_w)) + ((params.p_w_c_n && params.p_b_c_b_b_f === 'Close') ? -2.935 : 0) + (params.p_r_s === 1 ? 3 : 0);
    let patternDepth = params.leanB_p_w
    let lengthPattern = 3
    let depthPattern = patternDepth

    const dutchDelModelFront = useMemo(() => {
        const freeSpace = 1;
        let cornerFreeSpaceW = (params.leanB_p_w - freeSpace) / 6;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.leanB_p_h - ((params.b_l_t_r_pB / 12) * params.leanB_p_w) :  params.leanB_p_h
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

        if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
        if (params.add_back_lean && (params.p_b_c_b_b_f === "Half Dutch End" || params.p_b_c_b_b_f === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.leanB_p_w / 2 - freeSpace), 0);

            if (params.p_b_c_b_b_f === "Half Dutch End") {
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanB_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanB_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
            } else {
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.leanB_p_w / 2 - freeSpace), leftHeight - freeSpace);
            }
            model.lineTo((params.leanB_p_w / 2 - freeSpace), 0);

            return model;
        } else {
            return []
        }
    }, [params.add_back_lean, params.leanB_p_w, params.leanB_p_h, params.p_b_c_b_b_f])

    const dutchDelModelBack = useMemo(() => {
        const freeSpace = 1;
        let cornerFreeSpaceW = (params.leanB_p_w - freeSpace) / 6;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.leanB_p_h - ((params.b_l_t_r_pB / 12) * params.leanB_p_w) :  params.leanB_p_h
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

        if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
        if (params.add_back_lean && (params.p_b_c_b_b_b === "Half Dutch End" || params.p_b_c_b_b_b === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.leanB_p_w / 2 - freeSpace), 0);

            if (params.p_b_c_b_b_b === "Half Dutch End") {
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanB_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanB_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
            } else {
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.leanB_p_w / 2 - freeSpace), leftHeight - freeSpace);
            }
            model.lineTo((params.leanB_p_w / 2 - freeSpace), 0);

            return model;
        } else {
            return []
        }
    }, [params.add_back_lean, params.leanB_p_w, params.leanB_p_h, params.p_b_c_b_b_b])
    

    // Front Wall - CSG   
    const frontWallModelObj = useMemo(() => {
        if (params.p_b_c_b_b_f == 'Open') return;
        let outerModel;
        let innerModel;
        let wainscotModel;

        //************************* */ inner wall geometry
        const frontWallModel = new THREE.Shape();
            if (params.p_b_c_b_b_f !== 'Open' || typeof(params.p_b_c_b_b_f) === 'object') {
                if (params.p_r_s === 1) {
                    frontWallModel.moveTo(-(params.leanB_p_w), frontWallCloseState);
                    frontWallModel.lineTo(-(params.leanB_p_w), params.leanB_p_h);
                    frontWallModel.lineTo(-(params.leanB_p_w), params.leanB_p_h + const_var.roofRegularDst);
                    frontWallModel.quadraticCurveTo(-(params.leanB_p_w), params.leanB_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pB / 12) / 10, 
                                                    -(params.leanB_p_w - const_var.roofRegularDst + 0.1), params.leanB_p_h + const_var.roofRegularDst * (2 + params.b_l_t_r_pB / 12))
                    frontWallModel.lineTo(0, params.leanB_p_h + ((params.b_l_t_r_pB / 12) * (params.leanB_p_w) + const_var.roofRegularDst * (2)));
                    frontWallModel.lineTo(0, frontWallCloseState);
                    frontWallModel.closePath();
                } else {
                    frontWallModel.moveTo(-params.leanB_p_w + 0.005, params.leanB_p_h);
                    frontWallModel.lineTo(0, params.leanB_p_h + params.leanB_p_w / 12 * params.b_l_t_r_pB);
                    frontWallModel.lineTo(0, frontWallCloseState + (params.p_r_s === 1 && 0.1));
                    frontWallModel.lineTo(-params.leanB_p_w + 0.005, frontWallCloseState + (params.p_r_s === 1 && 0.1));
                    frontWallModel.closePath();
                }
            }

        const meshFrontWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(frontWallModel, extrudeSettings(0.005)), new THREE.MeshStandardMaterial({ color: "brown" }))
        const meshFrontDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanFront', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: "red" }))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshDutchDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(dutchDelModelFront, extrudeSettings(1)), new THREE.MeshStandardMaterial({color: 'blue'}))

        let meshFrontWallModel_Temp = meshFrontWallModel.clone();
        meshFrontWallModel_Temp.rotateY(-Math.PI / 2);
        meshFrontWallModel_Temp.position.set(params.leanB_p_d / 2 - 0.03 , 0, -params.p_d / 2 - cbFrontBackWallOffset);
        meshFrontWallModel_Temp.updateMatrixWorld();
    
        let meshFrontDelModel_Temp = meshFrontDelModel.clone();
        meshFrontDelModel_Temp.rotateY(Math.PI / 2);
        meshFrontDelModel_Temp.position.set(params.leanB_p_d / 2 - 0.5, 0, 0);
        meshFrontDelModel_Temp.updateMatrixWorld();

        let meshSideInnerDelModel_Temp = meshSideDelModel.clone();
        meshSideInnerDelModel_Temp.position.set(-params.leanB_p_pos, 0, -params.p_d / 2 - params.leanB_p_w - 0.95);
        meshSideInnerDelModel_Temp.updateMatrixWorld();

        let meshDutchDelModel_Temp = meshDutchDelModel.clone();
        meshDutchDelModel_Temp.rotateY(Math.PI / 2);
        meshDutchDelModel_Temp.position.set(params.leanB_p_d / 2 - 0.5, 0, -params.p_d / 2 - params.leanB_p_w / 2);
        meshDutchDelModel_Temp.updateMatrixWorld();
    
        const meshFrontWallModel_CSG = CSG.fromMesh(meshFrontWallModel_Temp);
        const meshFrontDelModel_CSG = CSG.fromMesh(meshFrontDelModel_Temp);
        const meshSideInnerDelModel_CSG = CSG.fromMesh(meshSideInnerDelModel_Temp);
        const meshDutchDelModel_CSG = CSG.fromMesh(meshDutchDelModel_Temp);
    
        const frontWallModel_CSG = meshFrontWallModel_CSG.subtract(meshFrontDelModel_CSG);
        const frontInnerWallDelModel_CSG =  frontWallModel_CSG.subtract(meshSideInnerDelModel_CSG);
        const meshFrontInnerModel_CSG = frontInnerWallDelModel_CSG.subtract(meshDutchDelModel_CSG);

        const CSGFrontWallModel = CSG.toMesh(
            meshFrontInnerModel_CSG,
            new THREE.Matrix4()
        )

        innerModel = CSGFrontWallModel.geometry

        //************************* */ outer wall geomety (grooves pattern)
        let wallpanelValue = (params.p_r_s === 1) ?  frontWallCloseState + 0.1 : frontWallCloseState
        const frontWallCutModel = new THREE.Shape();
        if (params.p_r_s === 1) {
            frontWallCutModel.moveTo(-(params.p_d / 2 + cbFrontBackWallOffset + params.leanB_p_w), frontWallCloseState);
            frontWallCutModel.lineTo(-(params.p_d / 2 + cbFrontBackWallOffset + params.leanB_p_w), params.leanB_p_h);
            frontWallCutModel.lineTo(-(params.p_d / 2 + cbFrontBackWallOffset + params.leanB_p_w), params.leanB_p_h + const_var.roofRegularDst);
            frontWallCutModel.quadraticCurveTo(-(params.p_d / 2 + cbFrontBackWallOffset + params.leanB_p_w), params.leanB_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pB / 12) / 10, 
                                               -(params.p_d / 2 + cbFrontBackWallOffset + params.leanB_p_w - const_var.roofRegularDst + 0.1), params.leanB_p_h + const_var.roofRegularDst * (2 + params.b_l_t_r_pB / 12))
            frontWallCutModel.lineTo(-(params.p_d / 2 + cbFrontBackWallOffset), params.leanB_p_h + ((params.b_l_t_r_pB / 12) * (params.leanB_p_w) + const_var.roofRegularDst * (2)));
            frontWallCutModel.lineTo(-(params.p_d / 2 + cbFrontBackWallOffset), frontWallCloseState);
            frontWallCutModel.closePath();
        } else {
            frontWallCutModel.moveTo(-(params.p_d / 2 + cbFrontBackWallOffset), params.leanB_p_h + ((params.b_l_t_r_pB / 12) * (params.leanB_p_w))); //right lean left top
            frontWallCutModel.lineTo(-(params.p_d / 2 + cbFrontBackWallOffset + params.leanB_p_w + cbFrontBackWallOffset), params.leanB_p_h); //right lean right top
            frontWallCutModel.lineTo(-(params.p_d / 2 + cbFrontBackWallOffset + params.leanB_p_w + cbFrontBackWallOffset), wallpanelValue); //right lean right bottom
            frontWallCutModel.lineTo(-(params.p_d / 2 + cbFrontBackWallOffset), wallpanelValue); //right lean left bottom
            frontWallCutModel.closePath();
        }

        const meshWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLength,isPattern), extrudeSettings(patternDepth)))  
        const meshGableDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(frontWallCutModel, extrudeSettings(1)))

        let meshGableDelModel_Temp = meshGableDelModel.clone();
        meshGableDelModel_Temp.position.set(params.leanB_p_d / 2 + 0.5,0,0);
        meshGableDelModel_Temp.rotation.set(0,Math.PI / -2,0);
        meshGableDelModel_Temp.updateMatrixWorld();

        let meshWallModel_Temp = meshWallModel.clone();
        meshWallModel_Temp.position.set(verticalHorizontalPos.x,verticalHorizontalPos.y,verticalHorizontalPos.z - 0.15);
        meshWallModel_Temp.rotation.set(verticalHorizontalRot.x,verticalHorizontalRot.y,verticalHorizontalRot.z);
        meshWallModel_Temp.updateMatrixWorld();

        let meshSideOuterDelModel_Temp = meshSideDelModel.clone();
        meshSideOuterDelModel_Temp.position.set(-params.leanB_p_pos, 0, -params.p_d / 2 - params.leanB_p_w - 0.8);
        meshSideOuterDelModel_Temp.updateMatrixWorld();

        const meshWallModel_CSG = CSG.fromMesh(meshWallModel_Temp);
        const meshGableDelModel_CSG = CSG.fromMesh(meshGableDelModel_Temp);
        const meshSideOuterDelModel_CSG = CSG.fromMesh(meshSideOuterDelModel_Temp);

        const wallModel_CSG = meshWallModel_CSG.subtract(meshFrontDelModel_CSG);
        const GableModel_CSG = wallModel_CSG.intersect(meshGableDelModel_CSG);
        const SideDelModel_CSG = GableModel_CSG.subtract(meshSideOuterDelModel_CSG);
        const MeshFrontOuterModel_CSG = SideDelModel_CSG.subtract(meshDutchDelModel_CSG);

        const CSGWallModel = CSG.toMesh(MeshFrontOuterModel_CSG,new THREE.Matrix4());

        outerModel = CSGWallModel.geometry;

        //************************* */ wainscot wall geometry
        let wainscotVerticalHorizontalPos = {"x": params.leanB_p_d /2,"y" : 0, "z" : -params.p_d / 2}
        let wainscotVerticalHorizontalRot = {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let patternDepthWS = params.leanB_p_w
        let lengthPatternWS = 3
        let depthPatternWS = patternDepthWS

        const meshFrontWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternWS,isPattern && params.wainscotTexture == "none"), extrudeSettings(depthPatternWS)))
        let meshFrontWainscotModel_Temp = meshFrontWainscotModel.clone();
        meshFrontWainscotModel_Temp.position.set(wainscotVerticalHorizontalPos.x,wainscotVerticalHorizontalPos.y,wainscotVerticalHorizontalPos.z - 0.15);
        meshFrontWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRot.x,wainscotVerticalHorizontalRot.y,wainscotVerticalHorizontalRot.z);
        meshFrontWainscotModel_Temp.updateMatrixWorld();

        const meshFrontWainscotModel_CSG = CSG.fromMesh(meshFrontWainscotModel_Temp);

        const frontWainscotModel_CSG = meshFrontWainscotModel_CSG.subtract(meshFrontDelModel_CSG);
        const sideDelWainscotModel_CSG = frontWainscotModel_CSG.subtract(meshSideOuterDelModel_CSG);
        const finalFrontwainscotModel_CSG = sideDelWainscotModel_CSG.subtract(meshDutchDelModel_CSG);

        const CSGFrontWainscotModel = CSG.toMesh(
            finalFrontwainscotModel_CSG,
            new THREE.Matrix4()
            )

        wainscotModel = CSGFrontWainscotModel.geometry;

        return {outerModel, innerModel, wainscotModel};

    }, [params.wallTexture,params.wainscotTexture,params.p_b_c_b_b_f, params.p_r_s, params.leanB_p_w, params.leanB_p_h, params.b_l_t_r_pB, params.leanB_p_pos, frontWallCloseState, params.p_d,params.p_h, params.p_w, params.p_r_p, patternLength, patternDepth, lengthPattern, depthPattern, params.leanB_p_d, verticalHorizontalPos, verticalHorizontalRot, cbFrontBackWallOffset, const_var.newDoorsArray, params.p_w_c_n, isPattern])

    // Back Wall - CSG
    const backWallModelObj = useMemo(() => {
        if (params.p_b_c_b_b_b == 'Open') return;
        let outerModel;
        let innerModel;
        let wainscotModel;
        
        //************************* */ inner wall geometry
        const backWallModel = new THREE.Shape();
        if (params.p_b_c_b_b_b !== 'Open' || typeof(params.p_b_c_b_b_b) === 'object') {
            if (params.p_r_s === 1) {
                backWallModel.moveTo(-(params.leanB_p_w), backWallCloseState);
                backWallModel.lineTo(-(params.leanB_p_w), params.leanB_p_h);
                backWallModel.lineTo(-(params.leanB_p_w), params.leanB_p_h + const_var.roofRegularDst);
                backWallModel.quadraticCurveTo(-(params.leanB_p_w), params.leanB_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pB / 12) / 10, 
                                               -(params.leanB_p_w - const_var.roofRegularDst + 0.1), params.leanB_p_h + const_var.roofRegularDst * (2 + params.b_l_t_r_pB / 12))
                backWallModel.lineTo(0, params.leanB_p_h + ((params.b_l_t_r_pB / 12) * (params.leanB_p_w) + const_var.roofRegularDst * (2)));
                backWallModel.lineTo(0, backWallCloseState);
                backWallModel.closePath();
            } else {
                backWallModel.moveTo(-params.leanB_p_w + 0.005, params.leanB_p_h);
                backWallModel.lineTo(0, params.leanB_p_h + params.leanB_p_w / 12 * params.b_l_t_r_pB - 0.05);
                backWallModel.lineTo(0, backWallCloseState);
                backWallModel.lineTo(-params.leanB_p_w + 0.005, backWallCloseState);
                backWallModel.closePath();
            }
        }

        const meshBackWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallModel, extrudeSettings(0.005)))
        const meshBackDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanBack', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: "red" }))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshDutchDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(dutchDelModelBack, extrudeSettings(1)), new THREE.MeshStandardMaterial({color: 'blue'}))

        let meshBackWallModel_Temp = meshBackWallModel.clone();
        meshBackWallModel_Temp.rotateY(-Math.PI / 2);
        meshBackWallModel_Temp.position.set(-params.leanB_p_d / 2 + 0.03, 0, -params.p_d / 2 - cbFrontBackWallOffset);
        meshBackWallModel_Temp.updateMatrixWorld();
    
        let meshBackDelModel_Temp = meshBackDelModel.clone();
        meshBackDelModel_Temp.rotateY(Math.PI / 2);
        meshBackDelModel_Temp.position.set(-params.leanB_p_d / 2 - 0.5, 0, 0);
        meshBackDelModel_Temp.updateMatrixWorld();

        let meshSideInnerDelModel_Temp = meshSideDelModel.clone();
        meshSideInnerDelModel_Temp.position.set(-params.leanB_p_pos, 0, -params.p_d / 2 - params.leanB_p_w - 0.95);
        meshSideInnerDelModel_Temp.updateMatrixWorld();

        let meshDutchDelModel_Temp = meshDutchDelModel.clone();
        meshDutchDelModel_Temp.rotateY(Math.PI / 2);
        meshDutchDelModel_Temp.position.set(- params.leanB_p_d / 2 - 0.5,0, -params.p_d / 2 - params.leanB_p_w / 2);
        meshDutchDelModel_Temp.updateMatrixWorld();
    
        const meshBackWallModel_CSG = CSG.fromMesh(meshBackWallModel_Temp)
        const meshBackDelModel_CSG = CSG.fromMesh(meshBackDelModel_Temp)
        const meshSideInnerDelModel_CSG = CSG.fromMesh(meshSideInnerDelModel_Temp);
        const meshDutchDelModel_CSG = CSG.fromMesh(meshDutchDelModel_Temp);
    
        const backWallModel_CSG = meshBackWallModel_CSG.subtract(meshBackDelModel_CSG);
        const SideInnerDelModel_CSG =  backWallModel_CSG.subtract(meshSideInnerDelModel_CSG);
        const meshBackInnerModel_CSG = SideInnerDelModel_CSG.subtract(meshDutchDelModel_CSG);

        const CSGBackWallModel = CSG.toMesh(
            meshBackInnerModel_CSG,
            new THREE.Matrix4()
        )
    
        innerModel = CSGBackWallModel.geometry;

        //************************* */ outer wall geometry
        let verticalHorizontalPosB = {"x": params.leanB_p_d /-2 - 0.0025,"y" : ((params.p_w_c_n && params.p_b_c_b_b_b === 'Close') ? 2.935 : 0), "z" : params.p_d / -2 - params.leanB_p_w}
        let verticalHorizontalRotB = {"x":0,"y" : 0,"z" : Math.PI / 2}
        let patternLengthB = params.leanB_p_h + ((params.b_l_t_r_pB / 12) * (params.leanB_p_w)) + ((params.p_w_c_n && params.p_b_c_b_b_b === 'Close') ? -2.935 : 0) + (params.p_r_s === 1 ? 3 : 0);
        let patternDepthB = params.leanB_p_w;

        const backWallCutModel = new THREE.Shape();
        if (params.p_r_s === 1) {
            backWallCutModel.moveTo(-(params.p_d / 2 + cbFrontBackWallOffset + params.leanB_p_w), backWallCloseState);
            backWallCutModel.lineTo(-(params.p_d / 2 + cbFrontBackWallOffset + params.leanB_p_w), params.leanB_p_h);
            backWallCutModel.lineTo(-(params.p_d / 2 + cbFrontBackWallOffset + params.leanB_p_w), params.leanB_p_h + const_var.roofRegularDst);
            backWallCutModel.quadraticCurveTo(-(params.p_d / 2 + cbFrontBackWallOffset + params.leanB_p_w), params.leanB_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pB / 12) / 10, 
                                              -(params.p_d / 2 + cbFrontBackWallOffset + params.leanB_p_w - const_var.roofRegularDst + 0.1), params.leanB_p_h + const_var.roofRegularDst * (2 + params.b_l_t_r_pB / 12))
            backWallCutModel.lineTo(-(params.p_d / 2 + cbFrontBackWallOffset), params.leanB_p_h + ((params.b_l_t_r_pB / 12) * (params.leanB_p_w) + const_var.roofRegularDst * (2)));
            backWallCutModel.lineTo(-(params.p_d / 2 + cbFrontBackWallOffset), backWallCloseState);
            backWallCutModel.closePath();
        } else {
            backWallCutModel.moveTo(-(params.p_d / 2), params.leanB_p_h + ((params.b_l_t_r_pB / 12) * (params.leanB_p_w))); //right lean left top
            backWallCutModel.lineTo(-(params.p_d / 2 + params.leanB_p_w + cbFrontBackWallOffset), params.leanB_p_h); //right lean right top
            backWallCutModel.lineTo(-(params.p_d / 2 + params.leanB_p_w + cbFrontBackWallOffset), backWallCloseState); //right lean right bottom
            backWallCutModel.lineTo(-(params.p_d / 2), backWallCloseState); //right lean left bottom
        }

        const meshWallModelB = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthB,isPattern), extrudeSettings(patternDepthB)))  
        const meshGableDelModelB = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallCutModel, extrudeSettings(1)))
    
        let meshGableDelModel_TempB = meshGableDelModelB.clone();
        meshGableDelModel_TempB.position.set(params.leanB_p_d / -2 + 0.5,0,0);
        meshGableDelModel_TempB.rotation.set(0,Math.PI / -2,0);
        meshGableDelModel_TempB.updateMatrixWorld();
    
        let meshWallModel_TempB = meshWallModelB.clone();
        meshWallModel_TempB.position.set(verticalHorizontalPosB.x,verticalHorizontalPosB.y,verticalHorizontalPosB.z - 0.15);
        meshWallModel_TempB.rotation.set(verticalHorizontalRotB.x,verticalHorizontalRotB.y,verticalHorizontalRotB.z);
        meshWallModel_TempB.updateMatrixWorld();

        let meshSideOuterDelModel_Temp = meshSideDelModel.clone();
        meshSideOuterDelModel_Temp.position.set(-params.leanB_p_pos, 0, -params.p_d / 2 - params.leanB_p_w - 0.8);
        meshSideOuterDelModel_Temp.updateMatrixWorld();
    
        const meshWallModel_CSGB = CSG.fromMesh(meshWallModel_TempB);
        const meshGableDelModel_CSGB = CSG.fromMesh(meshGableDelModel_TempB);
        const meshSideOuterDelModel_CSG = CSG.fromMesh(meshSideOuterDelModel_Temp);
    
        const wallModel_CSGB = meshWallModel_CSGB.subtract(meshBackDelModel_CSG);
        const GableModel_CSGB = wallModel_CSGB.intersect(meshGableDelModel_CSGB);
        const SideOuterDelModel_CSG = GableModel_CSGB.subtract(meshSideOuterDelModel_CSG);
        const MeshFrontOuterModel_CSG = SideOuterDelModel_CSG.subtract(meshDutchDelModel_CSG);
    
        const CSGWallModelB = CSG.toMesh(MeshFrontOuterModel_CSG,new THREE.Matrix4())

        outerModel = CSGWallModelB.geometry;

        //************************* */ outer wall wainscot geometry
        let patternDepthBWS = params.leanB_p_w;
        let wainscotVerticalHorizontalPosB = {"x": params.leanB_p_d /-2 - 0.0025,"y" : 0, "z" : params.p_d / -2 - params.leanB_p_w}
        let wainscotVerticalHorizontalRotB = {"x":0,"y" : 0,"z" : Math.PI / 2}
        let lengthPatternB = 3
        let depthPatternB = patternDepthBWS

        const meshBackWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternB,isPattern && params.wainscotTexture == "none"), extrudeSettings(depthPatternB)))
        let meshBackWainscotModel_Temp = meshBackWainscotModel.clone();
        meshBackWainscotModel_Temp.position.set(wainscotVerticalHorizontalPosB.x,wainscotVerticalHorizontalPosB.y,wainscotVerticalHorizontalPosB.z - 0.15);
        meshBackWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRotB.x,wainscotVerticalHorizontalRotB.y,wainscotVerticalHorizontalRotB.z);
        meshBackWainscotModel_Temp.updateMatrixWorld();

        const meshBackWainscotModel_CSG = CSG.fromMesh(meshBackWainscotModel_Temp);

        const backWainscotModel_CSG = meshBackWainscotModel_CSG.subtract(meshBackDelModel_CSG);
        const sideDelWainscotModel_CSG = backWainscotModel_CSG.subtract(meshSideOuterDelModel_CSG);
        const finalFrontwainscotModel_CSG = sideDelWainscotModel_CSG.subtract(meshDutchDelModel_CSG);

        const CSGBackWainscotModel = CSG.toMesh(
            finalFrontwainscotModel_CSG,
            new THREE.Matrix4()
            )
            
        wainscotModel = CSGBackWainscotModel.geometry;

        return {outerModel, innerModel, wainscotModel}

    }, [params.backLeanStoragePosition, params.wallTexture,params.wainscotTexture,params.p_b_c_b_b_b, params.p_r_s, params.leanB_p_w, params.b_l_t_r_pB, params.leanB_p_h, params.leanB_p_pos, backWallCloseState, params.p_h, params.p_w, params.p_r_p, params.p_v_w, params.leanB_p_d, params.p_d, cbFrontBackWallOffset, const_var.newDoorsArray, params.p_w_c_n, isPattern]);

    // Side Wall - CSG
    const sideWallModelObj = useMemo(() => {
        if (params.p_b_c_b_b_l == 'Open') return;
        let outerModel;
        let innerModel;
        let wainscotModel;

        //variable section
        let verticalDepth = params.leanB_p_d
        let horizontalDepth = params.leanB_p_d
        let VSPosition = params.leanB_p_d / -2
        let HSPosition = params.leanB_p_d / 2
    
        if(params.add_left_back_lean_porch && !params.add_right_back_lean_porch){
            VSPosition = params.leanB_p_d / -2 - params.leanB_p_w
            verticalDepth = params.leanB_p_d +  params.leanB_p_w
            horizontalDepth = params.leanB_p_d +  params.leanB_p_w
        } else if(!params.add_left_back_lean_porch && params.add_right_back_lean_porch){
            VSPosition = params.leanB_p_d / -2
            HSPosition = params.leanB_p_d / 2 + params.leanB_p_w
            verticalDepth = params.leanB_p_d +  params.leanB_p_w
            horizontalDepth = params.leanB_p_d +  params.leanB_p_w
        } else if(params.add_left_back_lean_porch && params.add_right_back_lean_porch){
            VSPosition = params.leanB_p_d / -2 - params.leanB_p_w
            HSPosition = params.leanB_p_d / 2 + params.leanB_p_w
            verticalDepth = params.leanB_p_d +  params.leanB_p_w + params.leanB_p_w
            horizontalDepth = params.leanB_p_d +  params.leanB_p_w + params.leanB_p_w
        }

        let verticalHorizontalPosS = {"x": HSPosition,"y" : ((params.p_w_c_n && (params.p_b_c_b_b_l === 'Close' || params.add_storage_check_back)) ? 2.935 : 0), "z" : params.p_d / -2 - params.leanB_p_w - wallThickness - 0.16}
        let verticalHorizontalRotS = {"x":0,"y" : Math.PI / -2,"z" : Math.PI / 2}
        let patternLengthS = params.leanB_p_h + ((params.p_w_c_n && (params.p_b_c_b_b_l === 'Close' || params.add_storage_check_back)) ? -2.935 : 0) + (params.p_r_s === 1 ? 0.1 : 0);
        let patternDepthS = horizontalDepth

        let patternDepthSWS = horizontalDepth
        let lengthPatternSWS = 3
        let depthPatternSWS = patternDepthSWS

        let lengthR = params.leanB_p_d / 2
        let lengthL = params.leanB_p_d / 2

        if(params.add_left_back_lean_porch && !params.add_right_back_lean_porch){
            lengthR = params.leanB_p_d / 2 + params.leanB_p_w
        } else if(!params.add_left_back_lean_porch && params.add_right_back_lean_porch){
            lengthL = params.leanB_p_d / 2 + params.leanB_p_w
        } else if(params.add_left_back_lean_porch && params.add_right_back_lean_porch){
            lengthL = params.leanB_p_d / 2 + params.leanB_p_w
            lengthR = params.leanB_p_d / 2 + params.leanB_p_w
        }

        let wallpanelValue = (sideWallCloseState < 0) ? params.leanB_p_h + (params.p_r_s === 1 && 0.1) : sideWallCloseState

        //************************* */ inner wall geometry
        const sideWallModel = new THREE.Shape();
            sideWallModel.moveTo(-(params.leanB_p_d / 2 - 0.02), sideWallCloseState);
            sideWallModel.lineTo(-(params.leanB_p_d / 2 - 0.02) - sideWallLeftPorchSize, sideWallCloseState);
            sideWallModel.lineTo(-(params.leanB_p_d / 2 - 0.02) - sideWallLeftPorchSize, params.leanB_p_h + (params.p_r_s === 1 && 0.1));
            sideWallModel.lineTo((params.leanB_p_d / 2 - 0.02) + sideWallRightPorchSize, params.leanB_p_h + (params.p_r_s === 1 && 0.1));
            sideWallModel.lineTo((params.leanB_p_d / 2 - 0.02) + sideWallRightPorchSize, sideWallCloseState);
            sideWallModel.lineTo((params.leanB_p_d / 2 - 0.02), sideWallCloseState);
            sideWallModel.closePath();

        const storageSideWallModel = new THREE.Shape();
            storageSideWallModel.moveTo(-params.leanB_p_d / 2, 0);
            storageSideWallModel.lineTo(-params.leanB_p_d / 2, params.leanB_p_h + (params.leanB_p_w - 0.05) * params.b_l_t_r_pB / 12);
            storageSideWallModel.lineTo(-params.leanB_p_d / 2 + parseInt(params.add_storage_back), params.leanB_p_h + (params.leanB_p_w - 0.05) * params.b_l_t_r_pB / 12);
            storageSideWallModel.lineTo(-params.leanB_p_d / 2 + parseInt(params.add_storage_back), 0);
            storageSideWallModel.closePath();

        const meshSideWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(sideWallModel, extrudeSettings(0.005)))
        const meshStorageSideWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageSideWallModel, extrudeSettings(1)));
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanSide', 'wall'), extrudeSettings(1)))
        
        let meshSideWallModel_Temp = meshSideWallModel.clone();
        meshSideWallModel_Temp.position.set(0, 0, -params.p_d / 2 - params.leanB_p_w - cbFrontBackWallOffset + 0.03);
        meshSideWallModel_Temp.updateMatrixWorld();

        let meshStorageSideWallModel_Temp = meshStorageSideWallModel.clone();
        meshStorageSideWallModel_Temp.position.set(params.backLeanStoragePosition, 0, -params.p_d / 2 - params.leanB_p_w - cbFrontBackWallOffset - 0.5);
        meshStorageSideWallModel_Temp.updateMatrixWorld();
    
        let meshSideDelModel_Temp = meshSideDelModel.clone();
        // meshSideDelModel_Temp.position.set(alignPosOffset, 0, -params.p_d / 2 - params.leanB_p_w - cbFrontBackWallOffset - 0.5);
        meshSideDelModel_Temp.position.set(-params.leanB_p_pos, 0, -params.p_d / 2 - params.leanB_p_w - cbFrontBackWallOffset - 0.5);
        meshSideDelModel_Temp.updateMatrixWorld();
        
    
        const meshSideWallModel_CSG = CSG.fromMesh(meshSideWallModel_Temp)
        const meshStorageSideWallModel_CSG = CSG.fromMesh(meshStorageSideWallModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp)
    
        const sideWallModel_CSG = meshSideWallModel_CSG.subtract(meshSideDelModel_CSG)

        let storageWallDelModel_CSG;

        if(params.add_storage_check_back) {
            storageWallDelModel_CSG = sideWallModel_CSG.subtract(meshStorageSideWallModel_CSG)
        } else {
            storageWallDelModel_CSG = sideWallModel_CSG
        }

        const CSGSideWallModel = CSG.toMesh(
            storageWallDelModel_CSG,
            new THREE.Matrix4()
        )

        innerModel = CSGSideWallModel.geometry;

        //************************* */ outer wall geometry
        const sideWallCutModel = new THREE.Shape();
            sideWallCutModel.moveTo((lengthL), params.leanB_p_h + (params.p_r_s === 1 && 0.1));
            sideWallCutModel.lineTo(-(lengthR), params.leanB_p_h + (params.p_r_s === 1 && 0.1));
            sideWallCutModel.lineTo(-(lengthR), wallpanelValue);
            sideWallCutModel.lineTo((lengthL), wallpanelValue);
            sideWallModel.closePath();
        
        const meshSideWallModelPattern = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthS,isPattern), extrudeSettings(patternDepthS)));
        const meshWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(sideWallCutModel, extrudeSettings(1)))
        
        let meshWallModel_TempS = meshSideWallModelPattern.clone();
        meshWallModel_TempS.position.set(verticalHorizontalPosS.x,verticalHorizontalPosS.y,verticalHorizontalPosS.z);
        meshWallModel_TempS.rotation.set(verticalHorizontalRotS.x,verticalHorizontalRotS.y,verticalHorizontalRotS.z);
        meshWallModel_TempS.updateMatrixWorld();
    
        let meshWallDelModel_TempS = meshWallDelModel.clone();
        meshWallDelModel_TempS.position.set(0 , 0, params.p_d / -2 - params.leanB_p_w - 0.5);
        meshWallDelModel_TempS.updateMatrixWorld();
    
        const meshWallModel_CSGS = CSG.fromMesh(meshWallModel_TempS);
        const meshWallDelModel_CSGS = CSG.fromMesh(meshWallDelModel_TempS);
    
        const wallModel_CSGS = meshWallModel_CSGS.subtract(meshSideDelModel_CSG);
        const meshWallDel_CSGS = wallModel_CSGS.intersect(meshWallDelModel_CSGS);

        let storageWallDelModel_CSGS;

        if(params.add_storage_check_back) {
            storageWallDelModel_CSGS = meshWallDel_CSGS.subtract(meshStorageSideWallModel_CSG)
        } else {
            storageWallDelModel_CSGS = meshWallDel_CSGS
        }

        const CSGWallModelS = CSG.toMesh(storageWallDelModel_CSGS,new THREE.Matrix4());

        outerModel = CSGWallModelS.geometry

        //************************* */ wainscot wall geometry
        let wainscotVerticalHorizontalPosS = {"x": HSPosition,"y" : 0, "z" : params.p_d / -2 - params.leanB_p_w - wallThickness - 0.16}
        let wainscotVerticalHorizontalRotS = {"x":0,"y" : Math.PI / -2,"z" : Math.PI / 2}

        const meshSideWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternSWS,isPattern && params.wainscotTexture == "none"), extrudeSettings(depthPatternSWS)))
        let meshSideWainscotModel_Temp = meshSideWainscotModel.clone();
        meshSideWainscotModel_Temp.position.set(wainscotVerticalHorizontalPosS.x,wainscotVerticalHorizontalPosS.y,wainscotVerticalHorizontalPosS.z);
        meshSideWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRotS.x,wainscotVerticalHorizontalRotS.y,wainscotVerticalHorizontalRotS.z);
        meshSideWainscotModel_Temp.updateMatrixWorld();

        const meshSideWainscotModel_CSG = CSG.fromMesh(meshSideWainscotModel_Temp);

        const SideWainscotModel_CSG = meshSideWainscotModel_CSG.subtract(meshSideDelModel_CSG);
        const SideWainscotModelCSG = SideWainscotModel_CSG.intersect(meshWallDelModel_CSGS);

        let storageWainscotDelModel_CSG;

        if(params.add_storage_check_back) {
            storageWainscotDelModel_CSG = SideWainscotModelCSG.subtract(meshStorageSideWallModel_CSG)
        } else {
            storageWainscotDelModel_CSG = SideWainscotModelCSG
        }

        const CSGSideWainscotModel = CSG.toMesh(
            storageWainscotDelModel_CSG,
            new THREE.Matrix4()
            )

        wainscotModel = CSGSideWainscotModel.geometry;

        return {outerModel, innerModel, wainscotModel}
        
    }, [params.wallTexture,params.wainscotTexture,params.p_b_c_b_b_l, params.backLeanStoragePosition, params.p_r_s, params.leanB_p_d, sideWallLeftPorchSize, params.leanB_p_h, sideWallRightPorchSize, sideWallCloseState, params.add_storage_check_back, params.add_storage_back, params.p_w_c_n, params.p_d, cbFrontBackWallOffset, params.leanB_p_w, params.add_left_back_lean_porch, params.add_right_back_lean_porch, params.p_v_w, const_var.newDoorsArray, isPattern]);

    // --- front wall set    
    useMemo(() => {
        let tempWallCloseState;
        if (params.p_b_c_b_b_f === "Gable") {
            if (params.p_r_s === 1) {
                tempWallCloseState = params.leanB_p_h + 0.1;
            } else {
                tempWallCloseState = params.leanB_p_h - 0.2;
            }
        } else if (params.p_b_c_b_b_f === "One_Fourth_Close") {
            tempWallCloseState = params.leanB_p_h / 4 * 3;
        } else if (params.p_b_c_b_b_f === "Half_Close") {
            tempWallCloseState = params.leanB_p_h / 2;
        } else if (params.p_b_c_b_b_f === "Three_Fourth_Close") {
            tempWallCloseState = params.leanB_p_h / 4;
        } else if (params.p_b_c_b_b_f === "Close") {
            tempWallCloseState = 0;
        } else if (params.p_b_c_b_b_f === "Half Dutch End") {
            tempWallCloseState = 0;
        } else if (params.p_b_c_b_b_f === "Half End") {
            tempWallCloseState = 0;
        } else {
            tempWallCloseState = -1;
        }

        // if(params.p_w_c_n && params.p_b_c_b_b_f == "Close") tempWallCloseState = 3;

        setFrontWallCloseState(tempWallCloseState);
    }, [params.p_b_c_b_b_f, params.leanB_p_h, params.p_r_s, params.p_w_c_n])

    // --- back wall set    
    useMemo(() => {
        let tempWallCloseState;
        if (params.p_b_c_b_b_b === "Gable") {
            if (params.p_r_s === 1) {
                tempWallCloseState = params.leanB_p_h + 0.1;
            } else {
                tempWallCloseState = params.leanB_p_h - 0.2
            }
        } else if (params.p_b_c_b_b_b === "One_Fourth_Close") {
            tempWallCloseState = params.leanB_p_h / 4 * 3;
        } else if (params.p_b_c_b_b_b === "Half_Close") {
            tempWallCloseState = params.leanB_p_h / 2;
        } else if (params.p_b_c_b_b_b === "Three_Fourth_Close") {
            tempWallCloseState = params.leanB_p_h / 4;
        } else if (params.p_b_c_b_b_b === "Close") {
            tempWallCloseState = 0;
        } else if (params.p_b_c_b_b_b === "Half Dutch End") {
            tempWallCloseState = 0;
        } else if (params.p_b_c_b_b_b === "Half End") {
            tempWallCloseState = 0;
        } else {
            tempWallCloseState = -1;
        }
        // if(params.p_w_c_n && params.p_b_c_b_b_b == "Close") tempWallCloseState = 3;

        setBackWallCloseState(tempWallCloseState);
    }, [params.p_b_c_b_b_b, params.leanB_p_h, params.p_r_s, params.p_w_c_n])

    // --- side wall set
    useMemo(() => {
        let tempWallCloseState = 0;
        if (params.p_b_c_b_b_l === 'Open' || typeof(params.p_b_c_b_b_l) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseState = params.leanB_p_h + 0.1;
            } else if (params.p_r_s === 2) {
                tempWallCloseState = params.leanB_p_h - 0.01;
            } else {
                tempWallCloseState = params.leanB_p_h;
            }
        } else if (params.p_b_c_b_b_l === "One_Fourth_Close") {
            tempWallCloseState = params.leanB_p_h / 4 * 3;
        } else if (params.p_b_c_b_b_l === "Half_Close") {
            tempWallCloseState = params.leanB_p_h / 2;
        } else if (params.p_b_c_b_b_l === "Three_Fourth_Close") {
            tempWallCloseState = params.leanB_p_h / 4;
        } else if (params.p_b_c_b_b_l === "Close") {
            tempWallCloseState = 0;
        } else {
            tempWallCloseState = params.leanB_p_h - 3 * params.p_b_c_b_b_l;
        }
                
        // if(params.p_w_c_n && params.p_b_c_b_b_l == "Close") tempWallCloseState = 3;

        setSideWallCloseState(tempWallCloseState);
    }, [params.p_b_c_b_b_l, params.leanB_p_h, params.p_r_s, params.p_w_c_n])
    
    // --- porch state
    useMemo(() => {
        if (params.add_left_back_lean_porch) {
            setSideWallLeftPorchSize(params.leanB_p_w);
        } else {
            setSideWallLeftPorchSize(0);
        }
    }, [params.add_left_back_lean_porch, params.leanB_p_w, params.p_r_s])

    useMemo(() => {
        if (params.add_right_back_lean_porch) {
            setSideWallRightPorchSize(params.leanB_p_w);
        } else {
            setSideWallRightPorchSize(0);
        }
    }, [params.add_right_back_lean_porch, params.leanB_p_w, params.p_r_s])
    
    const handleMouseEvent = (e) => {
        if (controls.isCheckActiveTab === 'doorwindow' && (const_var.focusedSection === "backlean" && (params.activeWall === "B_L_L_S_W" || params.activeWall === "B_L_R_S_W"))) {
            switch (e.type) {
                case 'pointerdown':
                case 'click':
                case 'pointermove':
                    e.stopPropagation();
                    break;
                default :
                    break
            }
        }
    };
    const eventHandlers = useMouseEvents(handleMouseEvent);

    // useMemo(() => {
    //     let array = const_var.newDoorsArray.filter((item) => item.userData.wallName === 'c_b_b_w' && item.height > params.leanB_p_h);
    //     for(let i=0; i<array.length; i++) {
    //         let item = array[i];
    //         const doorPositionX = item.positionX;
    //         const doorWidth = item.width
    //         const LeftStoragePos = params.leanB_p_pos - params.leanB_p_d / 2 + parseInt(params.add_storage_right)
    //         const RightStoragePos = params.leanB_p_pos - params.leanB_p_d / 2
    //         if((RightStoragePos >= (doorPositionX - doorWidth / 2)) && (LeftStoragePos <= (doorPositionX + doorWidth / 2))){
    //             setIsStorageSideWall(true)
    //             return;
    //         } 
    //         setIsStorageSideWall(false)
    //     }

    // }, [const_var.newDoorsArray, params.leanB_p_pos, params.leanB_p_d, params.add_storage_right, params.leanB_p_h])

    return (
        <>
            <>
                <group name='back_lean_side_wall' {...eventHandlers}>
                    {(params.p_b_c_b_b_l !== 'Open') && sideWallModelObj?.outerModel && 
                        <mesh name="B_L_S_W" geometry={sideWallModelObj?.outerModel} renderOrder={1}>
                            <MaterialOuterWallNew isPattern={isPattern} visibleSection={"backLean"} />
                        </mesh>
                    }
                    {/* Side Wainscot */}
                    {params.p_w_c_n == true && (params.p_b_c_b_b_l === "Close") && sideWallModelObj?.wainscotModel &&
                        <mesh name="B_L_F_W_wainscot" geometry={sideWallModelObj?.wainscotModel} position={[0,0,-0.005]} renderOrder={1}>
                            <MaterialWainScotWallNew isPattern={isPattern} visibleSection={"backLean"} />
                        </mesh>
                    }
                    {(params.p_b_c_b_b_l !== 'Open') && sideWallModelObj && sideWallModelObj?.innerModel && 
                        <mesh name="side" geometry={sideWallModelObj?.innerModel} position={[0, 0, wallThickness + 0.01]}>
                            <MaterialInnerWall visibleSection={"backLean"} />
                        </mesh>
                    }
                </group>
                {params.p_b_c_b_b_f !== 'Open' && frontWallModelObj?.outerModel &&
                    <mesh name="B_L_F_W" geometry={frontWallModelObj?.outerModel} renderOrder={1}>
                        <MaterialOuterWallNew isPattern={isPattern} visibleSection={"backLean"} />
                    </mesh>
                }
                {params.p_b_c_b_b_b !== 'Open' && backWallModelObj?.outerModel &&
                    <mesh name="B_L_B_W" geometry={backWallModelObj?.outerModel} renderOrder={1}>
                        <MaterialOuterWallNew isPattern={isPattern} visibleSection={"backLean"} />
                    </mesh>
                }

                {/* Front Wainscot */}
                {params.p_w_c_n == true && (params.p_b_c_b_b_f === "Close" || params.p_b_c_b_b_f === "Half Dutch End" || params.p_b_c_b_b_f === "Half End") && frontWallModelObj?.wainscotModel && 
                    <>
                        <mesh name="B_L_F_W_wainscot" geometry={frontWallModelObj?.wainscotModel} position={[0.001, 0, 0]} renderOrder={1}>
                            <MaterialWainScotWallNew isPattern={isPattern} visibleSection={"backLean"} />
                        </mesh>
                    </>
                }
                {/* Back Wainscot */} 
                {params.p_w_c_n == true && (params.p_b_c_b_b_b === "Close" || params.p_b_c_b_b_b === "Half Dutch End" || params.p_b_c_b_b_b === "Half End") && backWallModelObj?.wainscotModel &&
                    <>
                        <mesh name="B_L_B_W_wainscot" geometry={backWallModelObj?.wainscotModel} position={[-0.001, 0, 0]} renderOrder={1}>
                            <MaterialWainScotWallNew isPattern={isPattern} visibleSection={"backLean"} />
                        </mesh>
                    </>
                }
            </>

            <group name='in-side-wall'>
                {
                    params.p_b_c_b_b_f !== 'Open' && frontWallModelObj && frontWallModelObj?.innerModel &&
                    <mesh name="lean_front_leg_wall" geometry={frontWallModelObj?.innerModel} position={[-wallThickness - 0.01, 0, 0]}>
                        <MaterialInnerWall visibleSection={"backLean"} />
                    </mesh>
                }
                {
                    params.p_b_c_b_b_b !== 'Open' && backWallModelObj && backWallModelObj?.innerModel && <mesh name="lean_back_leg_wall" geometry={backWallModelObj?.innerModel} position={[wallThickness*2 + 0.01, 0, 0]}>
                        <MaterialInnerWall visibleSection={"backLean"} />
                    </mesh>
                }
            </group>
            
        </>
    )
}

export default WallModel